import React, { useState, useEffect } from 'react'
import './RecentUploads.css'

// 1) Just your video URLs + dates
const uploads = [
  { videoUrl: 'https://youtu.be/ZyMVpU3UBwg?si=DU4etfoWYajc2vZ1', date: 'Mar 20, 2025' },
  { videoUrl: 'https://youtu.be/lwzzQb_3-_I?si=WjvZp29pb7ZTdXol', date: 'Feb 10, 2025' },
  { videoUrl: 'https://youtu.be/lOOhtjcsaP0?si=aCAURCA9rOFl_zOa', date: 'Jan 29, 2025' },
  { videoUrl: 'https://youtu.be/7VD8Oa7-DwU?si=8lo-njiKydAAyQU5', date: 'Jan 24, 2025' },
  { videoUrl: 'https://youtu.be/TqN_96KKpSU?si=Uki0fTMPO2-o7gX5', date: 'Jan 21,, 2025' },
  { videoUrl: 'https://youtu.be/0ODsPu6J2LA?si=KtXpMBN5eBkvdoV0', date: 'Jan 21, 2025' },
    { videoUrl: 'https://youtu.be/3j_ePI92Yak?si=3WPZP4dKCUOpA9p_', date: 'Jan 17, 2025' },
      { videoUrl: 'https://youtu.be/rV9BU9k5nfk?si=XBselLv8jilKpZQK', date: 'Jan 14, 2025' },
]

// 2) oEmbed fetch helper
async function fetchOEmbedData(videoUrl) {
  const endpoint = 'https://www.youtube.com/oembed'
  const url = `${endpoint}?url=${encodeURIComponent(videoUrl)}&format=json`
  const res = await fetch(url)
  if (!res.ok) throw new Error('oEmbed failed')
  return res.json() // -> { title, thumbnail_url, … }
}

// 3) Single “card”
function UploadCard({ videoUrl, date }) {
  const [meta, setMeta] = useState({
    title: 'Loading…',
    thumbnail_url: '',
  })

  useEffect(() => {
    let alive = true
    fetchOEmbedData(videoUrl)
      .then(data => {
        if (!alive) return
        setMeta({ title: data.title, thumbnail_url: data.thumbnail_url })
      })
      .catch(() => {
        if (!alive) return
        setMeta({ title: 'Unable to load', thumbnail_url: '' })
      })
    return () => { alive = false }
  }, [videoUrl])

  return (
    <a
      className="upload-item"
      href={videoUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open "${meta.title}" on YouTube`}
    >
      <div
        className="thumb"
        style={{
          backgroundImage: meta.thumbnail_url
            ? `url(${meta.thumbnail_url})`
            : undefined,
        }}
      >
        <div className="play-overlay">
          <span className="play-icon">▶︎</span>
        </div>
      </div>
      <h3 className="upload-title">{meta.title}</h3>
      <time className="upload-date">{date}</time>
    </a>
  )
}

// 4) Grid wrapper
export default function RecentUploads() {
  return (
    <section className="recent-uploads">
      <h2 className="section-title">Recent uploads</h2>
      <div className="uploads-grid">
        {uploads.map((u, i) => (
          <UploadCard key={i} videoUrl={u.videoUrl} date={u.date} />
        ))}
      </div>
    </section>
  )
}
